import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export const useAuthGuard = (requiredRole) => {
  const navigate = useNavigate();

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem('user'));

    if (!user) {
      navigate('/login');
      return;
    }

    if (requiredRole && user.role !== requiredRole) {
      navigate('/');
    }
  }, [navigate, requiredRole]);
};